import ApiClient from './ApiClient';

class BulkSendsAPI extends ApiClient {
  constructor() {
    super('bulk_sends', { accountScoped: true });
  }
}

export default new BulkSendsAPI();
